"use client";

import dynamic from "next/dynamic";

import { getArticlesPromoSimpleSectionClass } from "./articles-promo-simple-section.styles";

export const DynamicArticlesPromoSimpleSection = dynamic(
  async () => import("./articles-promo-simple-section.component").then((module_) => module_.ArticlesPromoSimpleSection),
  {
    loading: () => <div className={getArticlesPromoSimpleSectionClass({ className: "min-h-[880px]" })} />,
  },
);
